module.exports = __webpack_public_path__ + "static/img/son3_active.4c2e8996.png";